'use client';

import Link from 'next/link';
import Flex from '~/components/customComponents/flex/Flex';
import { ROUTES_MAP } from '~/constants/routes';
import { useI18n } from '~/locales/client';
import { LocaleEnum } from '~/locales/resources';

type NoAccountYetClientProps = {
  locale: LocaleEnum;
};

/**
 * Client-side NoAccountYet component
 * @param locale - The locale to use
 * @returns NoAccountYet component
 */
const NoAccountYetClient = ({ locale }: NoAccountYetClientProps) => {
  const translate = useI18n();

  return (
    <Flex className="justify-center items-center mb-[-20px] md:mb-2">
      <Link
        href={ROUTES_MAP.authRegister}
        className="font-semibold text-sm md:text-base text-red-500 hover:text-secondary underline underline-offset-2"
      >
        {translate('page.login.no-account-yet-register-now' as never)}
      </Link>
    </Flex>
  );
};

export default NoAccountYetClient;
